<p-toast></p-toast>

<div class="card">
  <h2>Registro de Supervisor</h2>

  <form [formGroup]="supervisorForm" (ngSubmit)="onSubmit()">

    <div class="formgrid grid">
      <!-- Usuario - CON VALIDACIONES COMPLETAS -->
      <div class="field col-12 md:col-6">
        <label for="usuario">Usuario (Correo electrónico)*</label>
        <input id="usuario" type="email" pInputText formControlName="usuario" [maxlength]="50"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['usuario'].touched && f['usuario'].invalid}">

        <div class="p-error text-sm mt-1" *ngIf="f['usuario'].touched && f['usuario'].invalid">
          <small class="block" *ngIf="f['usuario'].errors?.['required']">
            ⚠ El usuario es requerido
          </small>
          <small class="block" *ngIf="f['usuario'].errors?.['email']">
            ⚠ Debe ser un correo electrónico válido (ej: usuario@dominio.com)
          </small>
          <small class="block" *ngIf="f['usuario'].errors?.['minlength']">
            ⚠ El usuario debe tener al menos 5 caracteres
          </small>
        </div>
      </div>

      <!-- Contraseña - CON VALIDACIÓN DE SEGURIDAD -->
      <div class="field col-12 md:col-6">
        <label for="password">Contraseña*</label>
        <input id="password" type="password" pInputText [maxlength]="18" formControlName="password"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['password'].touched && f['password'].invalid}">

        <div class="p-error text-sm mt-1" *ngIf="f['password'].touched && f['password'].invalid">
          <small class="block" *ngIf="f['password'].errors?.['required']">
            ⚠ La contraseña es requerida
          </small>
          <small class="block" *ngIf="f['password'].errors?.['minlength']">
            ⚠ La contraseña debe tener al menos 6 caracteres
          </small>
          <small class="block" *ngIf="f['password'].errors?.['maxlength']">
            ⚠ La contraseña no puede exceder 18 caracteres
          </small>
          <small class="block" *ngIf="f['password'].errors?.['pattern']">
            ⚠ La contraseña debe contener al menos: una mayúscula, una minúscula, un número y un carácter especial
            (@$!%*?&)
          </small>
        </div>
      </div>

      <!-- Nombre - CON VALIDACIÓN -->
      <div class="field col-12 md:col-6">
        <label for="nombre">Nombre*</label>
        <input id="nombre" type="text" pInputText [maxlength]="100" formControlName="nombre"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['nombre'].touched && f['nombre'].invalid}">

        <div class="p-error text-sm mt-1" *ngIf="f['nombre'].touched && f['nombre'].invalid">
          <small class="block" *ngIf="f['nombre'].errors?.['required']">
            ⚠ El nombre es requerido
          </small>
          <small class="block" *ngIf="f['nombre'].errors?.['pattern']">
            ⚠ El nombre solo debe contener letras y espacios
          </small>
        </div>
      </div>

      <!-- Alias - REQUERIDO -->
      <div class="field col-12 md:col-6">
        <label for="alias">Alias*</label>
        <input id="alias" type="text" pInputText formControlName="alias" [maxlength]="50"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['alias'].touched && f['alias'].invalid}">

        <div class="p-error text-sm mt-1" *ngIf="f['alias'].touched && f['alias'].invalid">
          <small class="block" *ngIf="f['alias'].errors?.['required']">
            ⚠ El alias es requerido
          </small>
        </div>
      </div>

      <!-- Primer Apellido - CON VALIDACIÓN -->
      <div class="field col-12 md:col-6">
        <label for="primerApellido">Apellido Paterno*</label>
        <input id="primerApellido" type="text" pInputText [maxlength]="100" formControlName="primerApellido"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['primerApellido'].touched && f['primerApellido'].invalid}">

        <div class="p-error text-sm mt-1" *ngIf="f['primerApellido'].touched && f['primerApellido'].invalid">
          <small class="block" *ngIf="f['primerApellido'].errors?.['required']">
            ⚠ El apellido paterno es requerido
          </small>
          <small class="block" *ngIf="f['primerApellido'].errors?.['pattern']">
            ⚠ Solo debe contener letras y espacios
          </small>
        </div>
      </div>

      <!-- Segundo Apellido -->
      <div class="field col-12 md:col-6">
        <label for="segundoApellido">Apellido Materno</label>
        <input id="segundoApellido" type="text" pInputText [maxlength]="100" formControlName="segundoApellido"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['segundoApellido'].touched && f['segundoApellido'].invalid}">

        <div class="p-error text-sm mt-1" *ngIf="f['segundoApellido'].touched && f['segundoApellido'].invalid">
          <small class="block" *ngIf="f['segundoApellido'].errors?.['pattern']">
            ⚠ Solo debe contener letras y espacios
          </small>
        </div>
      </div>

      <!-- Teléfono Móvil - CON VALIDACIÓN -->
      <div class="field col-12 md:col-4">
        <label for="telefonoMovil">Teléfono Móvil*</label>
        <input id="telefonoMovil" type="tel" pInputText [maxlength]="10" formControlName="telefonoMovil"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty border-red-500': f['telefonoMovil'].touched && f['telefonoMovil'].invalid}"
          placeholder="10 dígitos">

        <div class="p-error text-sm mt-1" *ngIf="f['telefonoMovil'].touched && f['telefonoMovil'].invalid">
          <small class="block" *ngIf="f['telefonoMovil'].errors?.['required']">
            ⚠ El teléfono móvil es requerido
          </small>
          <small class="block" *ngIf="f['telefonoMovil'].errors?.['pattern']">
            ⚠ El teléfono debe tener 10 dígitos numéricos
          </small>
        </div>
      </div>
    </div>

    <!-- Botones -->
    <div class="field col-12 flex gap-2 justify-content-start mt-3">
      <p-button type="button" label="Cancelar" (click)="cancelar()" styleClass="p-button-secondary mr-3">
      </p-button>
      <p-button type="submit" label="Guardar" icon="pi pi-save" [disabled]="supervisorForm.invalid">
      </p-button>
    </div>

    <!-- Mensaje de error general -->
    <div class="field col-12" *ngIf="supervisorForm.invalid && supervisorForm.touched">
      <small class="p-error">
        ⚠ El formulario contiene errores. Por favor, revise los campos marcados en rojo.
      </small>
    </div>

  </form>

</div>